/* =====================================================================
   SH4DE — animations « Kairo » + configurateur
   Aucune dépendance. Chargé avec defer, après sh4de-cart.js.
   ===================================================================== */
(function () {
  'use strict';

  var doc = document, html = doc.documentElement;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = window.requestAnimationFrame.bind(window);
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var money = function (c) {
    return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  };

  /* ------------------------------------------------------------------
     Boucle d'animation unique
  ------------------------------------------------------------------ */
  var loops = [], running = false, lastY = window.scrollY, scrollVel = 0;
  function frame(now) {
    var y = window.scrollY;
    scrollVel += ((y - lastY) - scrollVel) * 0.12;
    lastY = y;
    for (var i = 0; i < loops.length; i++) loops[i](now);
    raf(frame);
  }
  function addLoop(fn) {
    loops.push(fn);
    if (!running) { running = true; raf(frame); }
  }

  /* ------------------------------------------------------------------
     Découpage des titres en mots masqués
  ------------------------------------------------------------------ */
  function splitWords(el, cls, inner) {
    var idx = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = doc.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (tok) {
            if (!tok) return;
            if (/^\s+$/.test(tok)) { frag.appendChild(doc.createTextNode(' ')); return; }
            var w = doc.createElement('span'); w.className = cls;
            if (inner) {
              var i = doc.createElement('span'); i.textContent = tok; i.style.setProperty('--i', idx++); w.appendChild(i);
            } else { w.textContent = tok; w.setAttribute('data-w', idx++); }
            frag.appendChild(w);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1) { walk(n); }
      });
    })(el);
  }

  /* ------------------------------------------------------------------
     Panier : badge synchronisé + ouverture du tiroir depuis le header
  ------------------------------------------------------------------ */
  function setCount(n) {
    $$('[data-kr-count]').forEach(function (b) {
      b.textContent = n;
      b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
    });
  }
  function patchCart() {
    if (typeof window.renderCartToDrawer === 'function') {
      var orig = window.renderCartToDrawer;
      window.renderCartToDrawer = function (cart) {
        orig(cart);
        if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
      };
    }
    $$('[data-kr-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!$('#CartDrawer') || typeof window.openCartDrawer !== 'function') return;
        e.preventDefault();
        if (typeof window.refreshDrawerFromCart === 'function') window.refreshDrawerFromCart();
        window.openCartDrawer();
      });
    });
  }

  /* ------------------------------------------------------------------
     Header : verre au scroll, masquage, curseur glissant, menu mobile
  ------------------------------------------------------------------ */
  function header() {
    var h = $('[data-kr-header]'); if (!h) return;
    var last = window.scrollY, tick = false, menuOpen = false;
    function onScroll() {
      var y = window.scrollY;
      h.classList.toggle('is-scrolled', y > 24);
      if (!menuOpen) {
        if (y > last + 6 && y > 260) h.classList.add('is-hidden');
        else if (y < last - 6 || y < 140) h.classList.remove('is-hidden');
      }
      last = y;
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; raf(function () { onScroll(); tick = false; }); }
    }, { passive: true });
    onScroll();

    var nav = $('[data-kr-nav]');
    if (nav) {
      var glider = $('.kr-nav__glider', nav), links = $$('a', nav);
      var active = links.filter(function (a) { return a.classList.contains('is-active'); })[0];
      var moveTo = function (a) {
        if (!a) { glider.style.opacity = 0; return; }
        var nr = nav.getBoundingClientRect(), r = a.getBoundingClientRect();
        glider.style.opacity = 1;
        glider.style.width = r.width + 'px';
        glider.style.transform = 'translateX(' + (r.left - nr.left) + 'px)';
      };
      links.forEach(function (a) {
        a.addEventListener('mouseenter', function () { moveTo(a); });
        a.addEventListener('focus', function () { moveTo(a); });
      });
      nav.addEventListener('mouseleave', function () { moveTo(active); });
      window.addEventListener('resize', function () { moveTo(active); });
      moveTo(active);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { moveTo(active); });
    }

    var burger = $('[data-kr-burger]'), mnav = $('[data-kr-mnav]');
    if (burger && mnav) {
      var toggle = function (open) {
        menuOpen = open;
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        mnav.classList.toggle('is-open', open);
        html.style.overflow = open ? 'hidden' : '';
        if (open) h.classList.remove('is-hidden');
      };
      burger.addEventListener('click', function () { toggle(burger.getAttribute('aria-expanded') !== 'true'); });
      $$('a', mnav).forEach(function (a) { a.addEventListener('click', function () { toggle(false); }); });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggle(false); });
    }
  }

  /* ------------------------------------------------------------------
     Intro : le logo se trace, se remplit, puis vole jusqu'au header
  ------------------------------------------------------------------ */
  function ready() {
    html.classList.add('kr-ready');
    $$('[data-kr-words="hero"]').forEach(function (el) { el.classList.add('is-in'); });
    try { sessionStorage.setItem('kr-intro', '1'); } catch (e) {}
  }
  function intro() {
    var L = $('[data-kr-loader]');
    if (!L || !html.classList.contains('kr-intro')) { ready(); return; }
    var wrap = $('[data-kr-loader-logo]', L), stroke = $('.kr-logo__stroke', L), num = $('[data-kr-loader-num]', L);
    var D = 2200, t0 = null;
    var ease = function (p) { return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; };

    function fly() {
      var target = $('[data-kr-logo-target]');
      L.classList.add('is-leaving');
      if (target && wrap.animate) {
        var a = wrap.getBoundingClientRect(), b = target.getBoundingClientRect();
        var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
        var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
        var s = b.width / a.width;
        var anim = wrap.animate(
          [{ transform: 'translate(-50%,-50%)' },
           { transform: 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) scale(' + s + ')' }],
          { duration: 1150, delay: 120, easing: 'cubic-bezier(.7,0,.2,1)', fill: 'forwards' }
        );
        anim.onfinish = end;
      } else { setTimeout(end, 1200); }
    }
    function end() {
      html.classList.remove('kr-intro');
      L.parentNode && L.parentNode.removeChild(L);
      window.scrollTo(0, 0);
      ready();
    }
    function step(now) {
      if (t0 === null) t0 = now;
      var p = clamp((now - t0) / D, 0, 1), e = ease(p);
      stroke.style.strokeDashoffset = String(1 - e);
      num.textContent = Math.round(e * 100);
      if (p < 1) raf(step);
      else {
        L.classList.add('is-filled');
        setTimeout(fly, 900);
      }
    }
    raf(step);
  }

  /* ------------------------------------------------------------------
     Fond du hero : nébuleuse sombre qui dérive lentement (canvas)
     Anime en continu, sans dépendre d'un fichier vidéo.
  ------------------------------------------------------------------ */
  function heroBackground() {
    var c = $('[data-kr-bg]'); if (!c) return;
    var ctx = c.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var w = 0, h = 0, t = 0, visible = true;
    var blobs = [
      { cx: .26, cy: .32, r: .60, col: '58,61,68', sx: .012, sy: .009, px: 0.0, py: 1.7 },
      { cx: .76, cy: .20, r: .66, col: '38,40,46', sx: .010, sy: .013, px: 2.1, py: 0.4 },
      { cx: .55, cy: .74, r: .72, col: '26,27,32', sx: .008, sy: .011, px: 1.1, py: 2.6 },
      { cx: .14, cy: .80, r: .46, col: '70,74,83', sx: .011, sy: .008, px: 3.0, py: 1.0 }
    ];
    function size() {
      var r = c.parentElement.getBoundingClientRect();
      w = c.width = Math.max(2, Math.round(r.width * dpr));
      h = c.height = Math.max(2, Math.round(r.height * dpr));
    }
    function draw() {
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = '#050506';
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      var m = Math.max(w, h);
      blobs.forEach(function (b) {
        var x = (b.cx + Math.sin(t * b.sx + b.px) * .1) * w;
        var y = (b.cy + Math.cos(t * b.sy + b.py) * .1) * h;
        var r = b.r * m * .64;
        var g = ctx.createRadialGradient(x, y, 0, x, y, r);
        g.addColorStop(0, 'rgba(' + b.col + ',.8)');
        g.addColorStop(.55, 'rgba(' + b.col + ',.34)');
        g.addColorStop(1, 'rgba(' + b.col + ',0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
      });
      ctx.globalCompositeOperation = 'source-over';
    }
    size(); draw();
    window.addEventListener('resize', function () { size(); draw(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(c.parentElement);
    }
    if (reduce) return; // l'image fixe posée ci-dessus suffit ; on respecte la préférence système
    addLoop(function () {
      if (!visible || doc.hidden) return;
      t += 1;
      draw();
    });
  }

  /* ------------------------------------------------------------------
     Carrousel 3D (coverflow)
  ------------------------------------------------------------------ */
  function coverflow() {
    var root = $('[data-kr-cf]'); if (!root) return;
    var cards = $$('.kr-cf__card', root), n = cards.length; if (!n) return;
    var dotsBox = $('.kr-cf__dots', root), dots = [];
    var cur = 0, timer = null, drag = null, hover = false;
    if (dotsBox) {
      cards.forEach(function (_, i) {
        var b = doc.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1));
        b.addEventListener('click', function () { go(i); auto(); });
        dotsBox.appendChild(b); dots.push(b);
      });
    }
    function place() {
      var W = root.clientWidth, step = clamp(W * .205, 150, 300);
      cards.forEach(function (c, i) {
        var d = i - cur;
        if (d > n / 2) d -= n; if (d < -n / 2) d += n;
        var a = Math.abs(d);
        var x = d * step * (a > 2 ? 1 - (a - 2) * .1 : 1) + (d ? Math.sign(d) * step * .1 : 0);
        var z = -a * 130 - (a > 0 ? 40 : 0);
        var ry = -d * 20;
        var s = a === 0 ? 1.14 : 1 - Math.min(a, 3) * .045;
        c.style.transform = 'translate3d(' + x + 'px,' + (a * 6) + 'px,' + z + 'px) rotateY(' + ry + 'deg) scale(' + s + ')';
        c.style.zIndex = String(100 - Math.round(a * 10));
        c.style.opacity = a > 3 ? '0' : '1';
        c.style.pointerEvents = a > 3 ? 'none' : 'auto';
        c.classList.toggle('is-active', a === 0);
      });
      dots.forEach(function (b, i) { b.classList.toggle('is-on', i === cur); });
    }
    function go(i) { cur = (i + n) % n; place(); }
    function auto() {
      clearInterval(timer);
      if (reduce) return;
      timer = setInterval(function () { if (!hover && !drag && !doc.hidden) go(cur + 1); }, 3800);
    }
    root.addEventListener('mouseenter', function () { hover = true; });
    root.addEventListener('mouseleave', function () { hover = false; });
    cards.forEach(function (c, i) {
      c.addEventListener('click', function (e) {
        if (root._moved) { e.preventDefault(); return; }
        if (i !== cur) { e.preventDefault(); go(i); auto(); }
      });
    });
    root.addEventListener('pointerdown', function (e) { drag = { x: e.clientX, cur: cur }; root._moved = false; });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 8) { root._moved = true; root.classList.add('is-drag'); }
      var st = clamp(root.clientWidth * .12, 90, 170);
      var target = drag.cur - Math.round(dx / st);
      if (((target % n) + n) % n !== cur) go(target);
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      drag = null; root.classList.remove('is-drag'); auto();
      setTimeout(function () { root._moved = false; }, 60);
    });
    window.addEventListener('resize', place);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(cur + 1); auto(); }
      if (e.key === 'ArrowLeft') { go(cur - 1); auto(); }
    });
    place(); auto();
  }

  /* ------------------------------------------------------------------
     Histoire épinglée
  ------------------------------------------------------------------ */
  function story() {
    var s = $('[data-kr-story]'); if (!s) return;
    var slides = $$('[data-slide]', s), imgs = $$('[data-img]', s), bars = $$('[data-bar]', s);
    var num = $('[data-num]', s), n = slides.length, curIdx = -1, tick = false;
    if (!n) return;
    function update() {
      var total = s.offsetHeight - window.innerHeight;
      var r = s.getBoundingClientRect();
      var p = clamp(-r.top / Math.max(total, 1), 0, .9999);
      var f = p * n, i = Math.floor(f);
      if (i !== curIdx) {
        curIdx = i;
        slides.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
        imgs.forEach(function (el, k) { el.classList.toggle('is-on', k === i); el.classList.toggle('is-past', k < i); });
        if (num) num.textContent = '0' + (i + 1);
      }
      bars.forEach(function (b, k) { b.style.setProperty('--f', k < i ? 1 : (k === i ? (f - i).toFixed(3) : 0)); });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; raf(function () { update(); tick = false; }); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ------------------------------------------------------------------
     Manifeste : les mots s'allument avec le scroll
  ------------------------------------------------------------------ */
  function manifesto() {
    var m = $('[data-kr-mani]'); if (!m) return;
    splitWords(m, 'kr-mw', false);
    var words = $$('.kr-mw', m), tick = false;
    function update() {
      var r = m.getBoundingClientRect(), vh = window.innerHeight;
      var p = clamp((vh * .82 - r.top) / (r.height + vh * .1), 0, 1);
      var lit = p * (words.length + 6);
      words.forEach(function (w, i) { w.style.setProperty('--o', clamp(lit - i, 0, 1).toFixed(2)); });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; raf(function () { update(); tick = false; }); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ------------------------------------------------------------------
     Marquees (vitesse liée au scroll)
  ------------------------------------------------------------------ */
  function marquees() {
    $$('[data-kr-mq]').forEach(function (el) {
      var track = $('.kr-mq__track', el); if (!track) return;
      var dir = parseFloat(el.getAttribute('data-dir')) || -1;
      var speed = parseFloat(el.getAttribute('data-speed')) || 60;
      var x = 0, half = 0, visible = true, last = performance.now();
      function measure() { half = track.scrollWidth / 2; }
      measure(); window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(el);
      if (reduce) return;
      addLoop(function (now) {
        var dt = Math.min(now - last, 60) / 1000; last = now;
        if (!visible || !half) return;
        var boost = 1 + Math.min(Math.abs(scrollVel) * .22, 7);
        x += dir * speed * boost * dt;
        if (dir < 0 && x <= -half) x += half;
        if (dir > 0 && x >= 0) x -= half;
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      });
      if (dir > 0) x = -half;
    });
  }

  /* ------------------------------------------------------------------
     Cartes produit : photos en fondu
  ------------------------------------------------------------------ */
  function productCards() {
    $$('[data-kr-pc]').forEach(function (card) {
      var imgs = $$('.kr-pc__media img', card), pager = $('.kr-pc__pager', card), i = 0, hover = false, dots = [];
      if (!imgs.length) return;
      if (pager) imgs.forEach(function () { var d = doc.createElement('i'); pager.appendChild(d); dots.push(d); });
      function show(k) {
        i = (k + imgs.length) % imgs.length;
        imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === i); });
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      }
      show(0);
      card.addEventListener('mouseenter', function () { hover = true; });
      card.addEventListener('mouseleave', function () { hover = false; });
      if (!reduce && imgs.length > 1) setInterval(function () { if (!hover && !doc.hidden) show(i + 1); }, 2800 + Math.random() * 700);
    });
  }

  /* ------------------------------------------------------------------
     Apparitions au scroll, boutons magnétiques, parallaxe CTA
  ------------------------------------------------------------------ */
  function reveals() {
    $$('[data-kr-words]').forEach(function (el) {
      if (!el.querySelector('.kr-w')) splitWords(el, 'kr-w', true);
    });
    var els = $$('[data-kr-reveal],[data-kr-words]:not([data-kr-words="hero"])');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: .15, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function magnetic() {
    if (reduce || !window.matchMedia('(hover:hover)').matches) return;
    $$('.kr-btn').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .12) + 'px,' + ((e.clientY - r.top - r.height / 2) * .22) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }
  function parallax() {
    var els = $$('[data-kr-parallax]'); if (!els.length || reduce) return;
    var tick = false;
    function upd() {
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect(), vh = window.innerHeight;
        var p = clamp((vh - r.top) / (vh + r.height), 0, 1) - .5;
        el.style.transform = 'translate3d(0,' + (p * -70).toFixed(1) + 'px,0) scale(1.1)';
      });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; raf(function () { upd(); tick = false; }); } }, { passive: true });
    upd();
  }

  /* ------------------------------------------------------------------
     CONFIGURATEUR
  ------------------------------------------------------------------ */
  function configurator() {
    var root = $('[data-kr-conf]'); if (!root) return;
    var dataEl = $('[data-kr-conf-data]', root), products = [];
    try { products = JSON.parse(dataEl.textContent || '[]'); } catch (e) { products = []; }
    if (!products.length) { var er = $('[data-conf-err]', root); if (er) er.hidden = false; return; }

    var st = { step: 1, max: 1, p: null, v: null, q: 1, img: 0 };
    var stage = $('[data-prev-stage]', root), imgA = $('[data-img-a]', root), imgB = $('[data-img-b]', root);
    var thumbs = $('[data-thumbs]', root), badge = $('[data-badge]', root);
    var total = $('[data-total]', root), cta = $('[data-cta]', root), ctaLbl = $('[data-cta-label]', root);
    var steps = $$('[data-stepbtn]', root), panes = $$('[data-step]', root);
    var title = $('[data-step-title]', root), sub = $('[data-step-sub]', root), count = $('[data-step-count]', root);
    var prev = $('[data-prev]', root), next = $('[data-next]', root), nextLbl = $('[data-next-label]', root);
    var sizesBox = $('[data-sizes]', root), optsBox = $('[data-opts]', root);
    var form = $('[data-kr-form]', root), fId = $('[name=id]', form), fQty = $('[name=quantity]', form);
    var recP = $('[data-rec-piece]', root), recS = $('[data-rec-size]', root), recU = $('[data-rec-unit]', root);
    var qVal = $('[data-qty-val]', root);
    var TXT = [
      ['Type de pièce', 'Choisissez votre modèle de base'],
      ['Taille', 'La coupe est oversized, votre taille habituelle donne un rendu ample'],
      ['Récapitulatif', 'Vérifiez votre pièce avant de l\'ajouter']
    ];
    var ICON_CK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

    /* --- étape 1 : cartes pièces --- */
    optsBox.innerHTML = '';
    products.forEach(function (p, i) {
      var min = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'kr-opt'; b.setAttribute('data-piece', i);
      b.innerHTML = '<span class="kr-opt__ck">' + ICON_CK + '</span>' +
        '<div class="kr-opt__img">' + (p.images[0] ? '<img src="' + p.images[0] + '" alt="" loading="lazy">' : '') + '</div>' +
        '<strong></strong><span>Drop 1 · 600 GSM</span><em>' + money(min) + '</em>';
      $('strong', b).textContent = p.title;
      b.addEventListener('click', function () { pickPiece(i); });
      optsBox.appendChild(b);
    });

    function selectedVariant() { return st.p ? st.p.variants.filter(function (v) { return v.id === st.v; })[0] : null; }

    function pickPiece(i) {
      st.p = products[i]; st.v = null; st.img = 0;
      var only = st.p.variants.length === 1 ? st.p.variants[0] : null;
      if (only && only.available) st.v = only.id;
      buildSizes(); setImage(0, true); buildThumbs(); refresh();
    }

    /* --- étape 2 : tailles --- */
    function buildSizes() {
      sizesBox.innerHTML = '';
      if (!st.p) return;
      st.p.variants.forEach(function (v) {
        var b = doc.createElement('button');
        b.type = 'button'; b.className = 'kr-size'; b.textContent = v.title === 'Default Title' ? 'Unique' : v.title;
        if (!v.available) { b.disabled = true; var s = doc.createElement('small'); s.textContent = 'Épuisé'; b.appendChild(s); }
        b.addEventListener('click', function () { st.v = v.id; refresh(); });
        b.setAttribute('data-vid', v.id);
        sizesBox.appendChild(b);
      });
    }

    /* --- aperçu --- */
    var flip = false;
    function setImage(k, first) {
      if (!st.p || !st.p.images.length) return;
      k = (k + st.p.images.length) % st.p.images.length; st.img = k;
      var src = st.p.images[k], show = flip ? imgA : imgB, hide = flip ? imgB : imgA;
      flip = !flip;
      show.src = src; show.alt = st.p.title;
      var go = function () { show.classList.add('is-on'); hide.classList.remove('is-on'); };
      if (show.complete) go(); else show.onload = go;
      stage.classList.add('has-img');
      badge.textContent = st.p.title;
      $$('button', thumbs).forEach(function (t, j) { t.classList.toggle('is-on', j === k); });
    }
    function buildThumbs() {
      thumbs.innerHTML = '';
      if (!st.p) return;
      st.p.images.forEach(function (src, j) {
        var b = doc.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (j + 1));
        b.innerHTML = '<img src="' + src.replace('width=1200', 'width=200') + '" alt="" loading="lazy">';
        b.addEventListener('click', function () { setImage(j); });
        if (j === st.img) b.classList.add('is-on');
        thumbs.appendChild(b);
      });
    }
    (function dragThumbs() {
      var d = null;
      thumbs.addEventListener('pointerdown', function (e) { d = { x: e.clientX, l: thumbs.scrollLeft }; });
      window.addEventListener('pointermove', function (e) { if (d) thumbs.scrollLeft = d.l - (e.clientX - d.x); });
      window.addEventListener('pointerup', function () { d = null; });
    })();

    /* --- total animé --- */
    var shown = 0, tAnim = null;
    function setTotal(v) {
      if (tAnim) cancelAnimationFrame(tAnim);
      var from = shown, t0 = performance.now(), D = 550;
      (function f(now) {
        var p = clamp((now - t0) / D, 0, 1), e = 1 - Math.pow(1 - p, 3);
        shown = Math.round(from + (v - from) * e);
        total.textContent = money(shown);
        if (p < 1) tAnim = raf(f);
      })(t0);
    }

    /* --- rafraîchissement global --- */
    function refresh(dir) {
      var v = selectedVariant();
      var unit = v ? v.price : (st.p ? Math.min.apply(null, st.p.variants.map(function (x) { return x.price; })) : 0);
      setTotal(st.p ? unit * st.q : 0);

      $$('.kr-opt', optsBox).forEach(function (b, i) { b.classList.toggle('is-sel', st.p === products[i]); });
      $$('.kr-size', sizesBox).forEach(function (b) { b.classList.toggle('is-sel', +b.getAttribute('data-vid') === st.v); });

      var okStep = [!!st.p, !!st.v, true];
      st.max = !st.p ? 1 : (!st.v ? 2 : 3);
      if (st.step > st.max) st.step = st.max;

      steps.forEach(function (li, k) {
        var n = k + 1;
        li.classList.toggle('is-on', n === st.step);
        li.classList.toggle('is-done', n < st.step);
        li.classList.toggle('is-locked', n > st.max);
      });
      panes.forEach(function (p, k) {
        var on = k + 1 === st.step;
        if (on && !p.classList.contains('is-on')) { p.classList.toggle('is-back', dir === 'back'); }
        p.classList.toggle('is-on', on);
      });
      title.textContent = TXT[st.step - 1][0]; sub.textContent = TXT[st.step - 1][1];
      count.textContent = 'Étape ' + st.step + ' / 3';
      prev.disabled = st.step === 1;
      next.disabled = !okStep[st.step - 1];
      nextLbl.textContent = st.step === 3 ? 'Ajouter au panier' : 'Suivant';

      if (st.p) {
        recP.textContent = st.p.title;
        recS.textContent = v ? (v.title === 'Default Title' ? 'Unique' : v.title) : 'À choisir';
        recU.textContent = money(unit);
      }
      qVal.textContent = st.q;

      var missing = (st.p ? 0 : 1) + (st.v ? 0 : 1);
      var ready = !missing;
      cta.disabled = !ready; cta.classList.toggle('is-ready', ready);
      if (!cta.classList.contains('is-done')) ctaLbl.textContent = ready ? 'Ajouter au panier' : (missing + ' élément' + (missing > 1 ? 's' : '') + ' à choisir');
    }

    /* --- navigation --- */
    function go(n, dir) { st.step = clamp(n, 1, st.max); refresh(dir); }
    steps.forEach(function (li, k) {
      $('button', li).addEventListener('click', function () { if (k + 1 <= st.max) go(k + 1, k + 1 < st.step ? 'back' : ''); });
    });
    prev.addEventListener('click', function () { go(st.step - 1, 'back'); });
    next.addEventListener('click', function () { if (st.step < 3) go(st.step + 1); else add(); });
    cta.addEventListener('click', function () { add(); });
    $('[data-q-minus]', root).addEventListener('click', function () { st.q = Math.max(1, st.q - 1); refresh(); });
    $('[data-q-plus]', root).addEventListener('click', function () { st.q = Math.min(10, st.q + 1); refresh(); });

    function add() {
      if (!st.p || !st.v) return;
      fId.value = st.v; fQty.value = st.q;
      cta.classList.add('is-done'); ctaLbl.textContent = 'Ajouté ✓';
      setTimeout(function () { cta.classList.remove('is-done'); refresh(); }, 1800);
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }

    /* --- présélection ?piece=handle --- */
    var m = /[?&]piece=([^&]+)/.exec(location.search);
    if (m) {
      var idx = -1;
      products.forEach(function (p, i) { if (p.handle === decodeURIComponent(m[1])) idx = i; });
      if (idx > -1) { pickPiece(idx); st.max = 2; go(2); }
    }
    refresh();
  }

  /* ------------------------------------------------------------------
     Démarrage
  ------------------------------------------------------------------ */
  function boot() {
    patchCart();
    header();
    reveals();
    magnetic();
    parallax();
    heroBackground();
    coverflow();
    story();
    manifesto();
    marquees();
    productCards();
    configurator();
    intro();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
